export const snakeToCamel = field =>
  field.replace(/([-_][a-z])/g, group =>
    group
      .toUpperCase()
      .replace("-", "")
      .replace("_", "")
  );

export const camelToSnake = field =>
  field
    .split(/(?=[A-Z])/)
    .join("_")
    .toLowerCase();

export default function changeDataKeys(data, handler) {
  if (!Array.isArray(data) && data instanceof Object) {
    // eslint-disable-next-line prefer-const
    let newObject = {};
    Object.keys(data).forEach(key => {
      const newName = handler(key);
      if (data[key] === null || data[key] === undefined) {
        newObject[newName] = null;
      } else if (typeof data[key] !== "object") {
        newObject[newName] = data[key];
      } else if (Array.isArray(data[key])) {
        newObject[newName] = data[key].map(arrayItem =>
          changeDataKeys(arrayItem, handler)
        );
      } else {
        newObject[newName] = changeDataKeys(data[key], handler);
      }
    });
    return newObject;
  }
  if (Array.isArray(data) && data.length) {
    return data.map(arrayItem => changeDataKeys(arrayItem, handler));
  }
  return data;
}
